import { getSubdomain } from 'tldts'
import extractOrgAndEnvIdFromSubdomain from './extractOrgAndEnvIdFromSubdomain'

export function getApplicationSystemInfo() {
  const { applicationSystemSubdomains, fallbackLogoutRedirectUrl } = window

  const currentSubdomain = getSubdomain(window.location.href) || ''

  const { organization: subdomainOrganization, envId } =
    extractOrgAndEnvIdFromSubdomain(currentSubdomain)

  const dynamicSubdomains = [
    `${envId}`,
    `${envId}.${subdomainOrganization}`,
    ''
  ]

  const applicationSystemSubdomain = applicationSystemSubdomains?.find(
    (object) => {
      if (!!envId && !!subdomainOrganization) {
        return dynamicSubdomains.includes(object.des)
      }
      return object.des === currentSubdomain
    }
  )

  const owner =
    applicationSystemSubdomain?.subapplicationsystemowner ??
    applicationSystemSubdomain?.applicationsystemowner

  const isStringOwner = typeof owner === 'string'

  const logoutRedirectUrl = isStringOwner
    ? fallbackLogoutRedirectUrl
    : ((owner?.[0]?.logout_redirect_url as string) ?? fallbackLogoutRedirectUrl)

  return {
    ownerUuid: isStringOwner ? owner : owner?.[0]?.uuid,
    logoutRedirectUrl,
    ownerDes: !isStringOwner ? owner?.[0]?.des : '',
    logoForPDFReport: !isStringOwner
      ? (owner?.[0]?.logo_for_PDF_report as string)
      : ''
  }
}
